import React, { useState } from "react";
import { DEFAULT_PER_PAGE } from "../../../helpers/default";
import ContentBlock from "../../../components/Layout/ContentBlock";
import FilterMenu from "../../../components/Layout/FilterMenu";
import { useQuery } from "react-query";
import Axios from "axios";
import ContentValidation from "../../../components/common/ContentValidation";
import {
  Pagination,
  SelectInput,
  TextInput,
} from "../../../components/globals";
import TableColumnProduct from "../../../components/Products/Items/TableColumnProduct";
import TableFilterBox from "../../../components/common/TableFilterBox";
import moment from "moment";
import { AiOutlineCloudSync } from "react-icons/ai";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../../helpers/FunctionsGlobal";
import useFetch from "../../../hooks/useFetch";
import { formatDatePlus } from "../../../helpers/Utils";
import TabUi from "./TabUi";
import { CheckBoxInput } from "../../../components/common/Buttons";

const fetcher = async ({ queryKey }) => {
  const [key, { page, perPage, filterStr }] = queryKey;
  const response = await Axios.get(
    `/api/v1/${key}?page=${page}&per_page=${perPage}${filterStr}`
  );
  return response.data;
};

const initialFilters = {
  title_i_cont_any: "",
  identifier_i_cont_any: "",
  product_suppliers_supplier_id_in: undefined,
  product_suppliers_code_i_cont_any: "",
  ean_i_cont_any: "",
  product_suppliers_supplier_id_in: undefined,
  product_suppliers_quantity_gt: null,
};

const translates = {
  title_i_cont_any: "Title",
  identifier_i_cont_any: "Product code",
  product_suppliers_supplier_id_in: "Supplier",
  product_suppliers_code_i_cont_any: "Supplier code",
  ean_i_cont_any: "EAN",
  product_suppliers_supplier_id_in: "Department",
  product_suppliers_quantity_gt: "Positive QTY only",
};

const Products = ({ tabId, setTabId }) => {
  const { value: suppliers } = useFetch(
    "/api/v1/suppliers",
    {},
    [],
    (value) => {
      return value.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
    }
  );

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [filters, setFilters] = useState(initialFilters);
  const [filterStr, setFilterStr] = useState("");
  const [openProducts, setOpenProducts] = useState([]);
  const {
    isLoading,
    error,
    data: { totals = 0, data = [], sync_info = {} } = {},
    refetch,
  } = useQuery({
    queryKey: ["products", { page, perPage, filterStr }],
    queryFn: fetcher,
  });

  const handleToggle = (value) => {
    const currentIndex = openProducts.indexOf(value);
    const newChecked = [...openProducts];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setOpenProducts(newChecked);
  };

  return (
    <>
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={data.length}
          text2="Products"
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
        />
      </ContentBlock>
      <div className="col-12">
        <TabUi tabId={tabId} setTabId={setTabId} />
      </div>
      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          filter={true}
          onFilter={() => {
            if (generateParams(filters) == filterStr && page == 1) {
              return refetch();
            }
            setFilterStr(generateParams(filters));
            setPage(1);
          }}
          add={false}
          clearFilter={() => setFilters(initialFilters)}
        >
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap flex-1">
              {Object.entries(filters).map(([key, value]) =>
                key == "product_suppliers_supplier_id_in" ? (
                  <div className="px-1" key={key}>
                    <SelectInput
                      mode="multiple"
                      label={translates[key]}
                      name={key}
                      value={value}
                      options={suppliers}
                      style={{
                        width: "165px",
                      }}
                      onChange={(val) => {
                        setFilters((prev) => ({ ...prev, [key]: val }));
                      }}
                    />
                  </div>
                ) : key == "product_suppliers_quantity_gt" ? (
                  <div
                    className="px-1"
                    style={{ display: "flex", alignItems: "end" }}
                    key={key}
                  >
                    <CheckBoxInput
                      onChange={() => {
                        setFilters((prev) => ({
                          ...prev,
                          [key]: prev[key] !== null ? null : 0,
                        }));
                      }}
                      checked={filters[key] !== null}
                      text={translates[key]}
                    />
                  </div>
                ) : (
                  <div className="px-1" key={key}>
                    <TextInput
                      text={translates[key]}
                      name={key}
                      value={value}
                      style={{ width: "165px" }}
                      onKeyDown={handleKeyDown2(() => {
                        if (generateParams(filters) == filterStr && page == 1) {
                          return refetch();
                        }
                        setFilterStr(generateParams(filters));
                        setPage(1);
                      })}
                      onChange={onChangeUseState(setFilters)}
                    />
                  </div>
                )
              )}
            </div>

            <div className="d-flex justify-content-end align-items-start px-1">
              {sync_info && (
                <div className="d-flex align-items-center">
                  <AiOutlineCloudSync
                    className="mr-2"
                    color={"#C3C3C3"}
                    size={28}
                  />
                  <span style={{ color: "#C3C3C3", fontSize: 17 }}>
                    <b>{sync_info.body}:</b>{" "}
                    {moment(sync_info.updated_at).format("YYYY-MM-DD HH:mm")}
                  </span>
                </div>
              )}
            </div>
          </div>
        </TableFilterBox>
        <ContentValidation loader={isLoading} array={data} error={error}>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <table className="table mt-3">
              <thead>
                <tr className="text-muted">
                  <th className="text-black">Code</th>
                  <th className="text-black">VV SKU</th>
                  <th className="text-black">Title</th>
                  <th className="text-black">Suppliers</th>
                  <th className="text-black">Quantity</th>
                  <th className="text-black">BB</th>
                  <th className="text-black">VV</th>
                  <th className="text-black">Department</th>
                  <th className="text-black">Supplier code</th>
                  <th className="text-black">Supplier price</th>
                  <th className="text-black">E-price</th>
                  {/* <th className="text-black">R-price</th> */}
                  <th className="text-black">Cost-price + PVM</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  return (
                    <TableColumnProduct
                      key={item.id}
                      suppliers={filters.product_suppliers_supplier_id_in || []}
                      index={index}
                      item={item}
                      handleToggle={handleToggle}
                      openArray={openProducts}
                      refetchProducts={refetch}
                    />
                  );
                })}
              </tbody>
            </table>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </ContentValidation>
      </ContentBlock>
    </>
  );
};

export default Products;

const generateParams = (filters = {}) => {
  let filtStr = Object.entries(filters)
    .filter(([key, value]) => {
      if (value === null || value === undefined || value === "") return false;

      if (key === "lost_at") {
        const [startDate, endDate] = value;
        return startDate || endDate;
      }

      if (typeof value === "string") {
        return value.trim().length > 0;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      // Include numbers (even 0) and booleans
      return typeof value === "number" || typeof value === "boolean";
    })
    .map(([key, value]) => {
      if (key === "lost_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.join("&");
      }

      if (key.includes("_in")) {
        return value.map((item) => `q[${key}][]=${item}`).join("&");
      }

      return `q[${key}]=${value}`;
    })
    .join("&");

  if (filtStr !== "") {
    filtStr = "&" + filtStr;
  }
  return filtStr;
};
